export const getColorFromProgress = (progress) => {

    // Couleur blanche uniquement si la progression est à 0, sinon c'est entre rouge et vert
    // Permet de différencier les projets qui n'ont aucune tâche terminée (blanc) VS un projet avec au moins la partie
    // remplie par le commercial (rouge du coup)
    if (progress === 0) {
        return 'rgb(255, 255, 255)';
    }

    let red, green;

    if (progress <= 50) {
        red = 255;
        green = Math.round(progress * 5.1);  // Green de 0 à 255
    } else {
        // Transition du jaune au vert
        red = Math.round(255 - (progress - 50) * 5.1);  // Red de 255 à 0
        green = 255;
    }

    return `rgb(${red}, ${green}, 0)`;  // Bleu toujours à 0
};